module.exports = __webpack_public_path__ + "static/media/caballo_big.27b7cd08.png";